import { Component, OnInit, Input, OnChanges } from '@angular/core';
import * as _ from 'lodash';
import { AssessmentRequestService } from 'src/app/assess-requests/assess-requests.service';
import { groupDataModel } from 'src/app/common/models/GroupDataModel';
import { groupRulesDetailsModel } from 'src/app/common/models/GroupRulesDetailsModel';
import { pureRulesDetailsModel, ruleFlags } from 'src/app/common/models/PureRuleDetailsModel';
import { recipeModel } from 'src/app/common/models/recipeDetailsModel';
import { DataService } from 'src/app/common/services/data.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-edit-group-rules',
  templateUrl: './edit-group-rules.component.html',
  styleUrls: ['./edit-group-rules.component.scss']
})
export class EditGroupRulesComponent implements OnInit, OnChanges {
  loading = false;
  loadingMsg = 'Fetching SIR details..';
  step = 0;
  marketsToSelect = [];
  editRuleFlow = false;
  viewRuleFlow = false;
  selectedMarket;
  parentRpcParallelRule;
  rpcsForEditRule = [];
  cascadeRPC = true;
  ruleTypeIdVal;
  rpcsForEditRulestatus = [];
  groupData = {
    substanceData: []
  };
  confGroupData = {
    groupId: '',
    groupName: '',
    groupType: '',
    substanceData: []
  };
  subChildRefreshKey = 0;
  @Input() key: number;
  @Input() reqData: any[] = [];
  @Input() parentRuleId: any;
  constructor(public dataServiceObj: DataService, private assessRequestRa: AssessmentRequestService) { }
  /* istanbul ignore next */
  ngOnChanges(): void {
    this.resetComponent();
}
  /* istanbul ignore next */
  ngOnInit() {
    this.editRuleFlow = false;
    this.viewRuleFlow = false;
    this.dataServiceObj.getruleToEdit().subscribe((value) => {
      if (value !== null) {
        this.editRuleFlow = true;
        this.ruleTypeIdVal = value.ruleTypeId;
        if (value.markets) {
          this.selectedMarket = value.markets[0].marketName;
          recipeModel.marketDetails = value.markets[0];
          this.marketsToSelect.push(recipeModel.marketDetails);
          pureRulesDetailsModel.CascadeRpc = 'Y';
        }
        this.parentRpcParallelRule = value.rpcid;
        for (const val of value.rpcs) {
          this.rpcsForEditRule.push(val.rpcFullText);
          this.rpcsForEditRulestatus.push(val.mrpcStatus);
        }
        this.applyCloneMarketRpc();
        this.getSirDetailsBasedOnId(value);
        groupRulesDetailsModel.CascadeRpc = 'Y';
      } else {
        this.editRuleFlow = false;
      }
    });
    this.dataServiceObj.expandedPanel.subscribe((result) => { // setting the expanded panel
      if (result) {
        this.setStep(Number(result));
      }
    });
    if (ruleFlags.viewRule) {
      this.editRuleFlow = false;
      this.viewRuleFlow = true;
    } else if (ruleFlags.editRule) {
      this.editRuleFlow = true;
      this.viewRuleFlow = false;
    }
  }
  /* istanbul ignore next */
  resetComponent() {
    this.editRuleFlow = ruleFlags.editRule;
    this.viewRuleFlow = ruleFlags.viewRule;
    this.subChildRefreshKey ++;
  }
  /* overrides the source rule's market/RPC with the market/RPC chosen on the clone screen */
  private applyCloneMarketRpc(): void {
    const cloneRule = this.reqData && this.reqData[0];
    const mrpc = cloneRule && Array.isArray(cloneRule.MRPCs) ? cloneRule.MRPCs[0] : null;
    if (!mrpc) {
      return;
    }
    recipeModel.marketDetails = { marketId: mrpc.marketId, marketName: mrpc.marketName, clusterId: null, clusterName: null, marketFullText: null, parentMarket: null };
    this.selectedMarket = mrpc.marketName;
    this.marketsToSelect = [recipeModel.marketDetails];
    this.parentRpcParallelRule = mrpc.RPCId;
    this.rpcsForEditRule = [mrpc.RPCFullText || mrpc.RPCName];
    this.rpcsForEditRulestatus = ['Active'];
  }
  setStep(index: number) {
    this.step = index;
  }
  /* istanbul ignore next */
  getSirDetailsBasedOnId(value) {
    const normalizeSubstanceId = (id: any) => String(id || '').trim().toLowerCase().replace(/[^a-z0-9]/g, '');
    // tslint:disable-next-line: prefer-const
    let confSirIds = []; let sirIds = [];
    this.loading = true;
    sirIds = value.substanceGroup.substanceIds;
    if (value.ruleTypeID === 43) {
      this.confGroupData = {
        groupId: value.conflictingSubstanceGroup.groupId,
        groupName: value.conflictingSubstanceGroup.groupName,
        groupType: value.conflictingSubstanceGroup.groupType,
        substanceData: []
      };
      confSirIds = value.conflictingSubstanceGroup.substanceIds;
      sirIds = sirIds.concat(confSirIds);
    }
    let cfdata = null;
    const subgroupCfInputBySirId = new Map<string, string>();
    const subgroupList = Array.isArray(value && value.substanceSubgroupsToSirList)
      ? value.substanceSubgroupsToSirList
      : [];
    subgroupList.forEach((subgroup: any) => {
      const sirIdKey = normalizeSubstanceId(subgroup && (subgroup.sirId || subgroup.SirId || subgroup.sirid || subgroup.substanceId || subgroup.SubstanceId));
      const cfInputValue = String(subgroup && (subgroup.cfInputData || subgroup.cfInput || subgroup.CFInputData) || '').trim();
      if (sirIdKey && cfInputValue) {
        subgroupCfInputBySirId.set(sirIdKey, cfInputValue);
      }
    });
    this.loadingMsg = 'Fetching data from SIR';
    let distinctSirIds = sirIds.filter((n, i) => sirIds.indexOf(n) === i);
    distinctSirIds = _.without(distinctSirIds, null);
    // to get sir details for substances in group
    // tslint:disable-next-line: no-shadowed-variable
    const apiurlforsir = environment.APIFAsTRule + '/rules/substances/SIRID/cfRequired/y';
    let substanceGroupData: any;
    this.assessRequestRa.postData(apiurlforsir, distinctSirIds).subscribe((response) => {
      if (response) {
        this.loading = false;
        substanceGroupData = {
          groupId: value.substanceGroup.groupId,
          groupName: value.substanceGroup.groupName,
          groupType: value.substanceGroup.groupType,
          substanceData: [],
          conflictingGroupData: [],
        };
        response.forEach(groupsub => {
          if (groupsub.cfDetails != null && groupsub.cfDetails.length > 0) {
            cfdata = groupsub.cfDetails[0].cfDisplayText;
          } else {
            cfdata = null;
          }
          const sirId = groupsub && (groupsub.sirId || groupsub.substanceId) ? (groupsub.sirId || groupsub.substanceId) : '';
          const sirIdKey = normalizeSubstanceId(sirId);
          const cfInputFromSir = String(groupsub && (groupsub.cfInputData || groupsub.cfInput || groupsub.CFInputData) || '').trim();
          const cfInputFromRuleData = subgroupCfInputBySirId.get(sirIdKey) || '';
          const subData = {
            sirId,
            purecode: groupsub.pureCode,
            substanceName: this.changeToTitleCase(groupsub.substanceName),
            cas: groupsub.cas,
            parentCAS: groupsub.parentCAS,
            inciName: groupsub.inciName,
            ins: groupsub.ins,
            cfDetails: groupsub.cfDetails,
            cfInputData: cfInputFromRuleData || cfInputFromSir,
            cfdata: cfdata,
            einecs: groupsub.einecs,
            synonyms: groupsub.substanceName,
            pureDescription: groupsub.pureDescription
          };
          substanceGroupData.substanceData.push(subData);
        });
        this.groupData = substanceGroupData;
        Object.assign(groupDataModel, substanceGroupData);
        if (value.ruleTypeID === 43) {
          this.confGroupData.substanceData = this.groupData.substanceData.filter((value1) =>
            value.conflictingSubstanceGroup.substanceIds.find((val) => value1.sirId === val));
          substanceGroupData.substanceData = this.groupData.substanceData.filter(o => value.substanceGroup.substanceIds.find(o2 => o.sirId === o2));
          substanceGroupData.conflictingGroupData.push(this.confGroupData);
        }
        this.dataServiceObj.setSelectedGroup(substanceGroupData);
        recipeModel.division = value.substanceGroup.updFullText;
      }
    }, (error) => {
      this.loading = false;
    });
  }

  changeToTitleCase(word: string) {
    if (!word) {
      return word;
    }
    return word[0].toUpperCase() + word.substr(1).toLowerCase();
  }

}
